import axios from "axios";
import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import Header from "../Header";
import SideBar from "../SideBar";
import BundleItem from "./BundleItem";
import Contractors from "./Contractors";
import Category from "./Category";

const CreateBundle = ({ props }) => {
  const history = useHistory();
  const [bundleName, setBundleName] = useState("");
  const [description, setDescription] = useState("");
  const [rating, setRating] = useState("");
  const [AproximateRate, setAproximateRate] = useState("");
  const [drawing, setDrawing] = useState([]);
  const [preview, setPreview] = useState([]);
  const [materialTypeList, setMaterialTypeList] = useState([]);
  const [brandList, setBrandList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false);
  const [selectedContractors, setSelectedContractors] = useState([]);
  const [selectedCategory, setSelectedCategory] = useState([]);
  const [bundleItems, setBundleItems] = useState([
    {
      inventory: "",
      section: "",
      materialType: "",
      brand: "",
      id: 1,
      //   variant: "",
    },
  ]);
  const handleBundleName = ({ target }) => setBundleName(target.value);
  const handleDescription = ({ target }) => setDescription(target.value);
  const handleRating = ({ target }) => setRating(target.value);
  const handleAproximateRate = ({ target }) => setAproximateRate(target.value);
  const handleFileChange = ({ target }) => {
    setDrawing(target.files[0]);
    setPreview(URL.createObjectURL(target.files[0]));
  };
  console.log("drawing", drawing);

  // const getBrandList = async () => {
  //   const response = await axios.get(
  //     `${process.env.REACT_APP_API_URL}brand/list`
  //   );
  //   if (response.data.data) setBrandList(response.data.data);
  // };

  const getBrandList = async () => {
    axios.get(`${process.env.REACT_APP_API_URL}brand/`, {}).then((res) => {
      if (res.data.brands) setBrandList(res.data.brands);
    });
  };

  const getMaterialTypeList = async () => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}material/list`
    );
    if (response.data.data) setMaterialTypeList(response.data.data);
  };

  const handleBundleItem = (item) => {
    let bundleItem = bundleItems.find((i) => i.id === item.id);
    bundleItem.inventory = item.inventory;
    bundleItem.section = item.section;
    bundleItem.materialType = item.materialType;
    bundleItem.brand = item.brand;
  };

  const handleContractorsChange = (selectedContractors) => {
    setSelectedContractors(selectedContractors);
  };

  const handleCategoryChange = ({ target }) => {
    setSelectedCategory(target.value);
    console.log("cateId", selectedCategory);
  };

  console.log("selCategory", selectedCategory.value);

  const addBundleItem = () => {
    let bundleItem = {
      inventory: "",
      section: "",
      materialType: "",
      brand: "",
      //   variant: "",
      id: bundleItems[bundleItems.length - 1].id + 1,
    };
    let newBundleItemList = [...bundleItems, bundleItem];
    setBundleItems(newBundleItemList);
  };

  const removeBundleItem = (id) => {
    if (bundleItems.length === 1) return;
    const bundleItemList = bundleItems.filter((i) => i.id !== id);
    setBundleItems(bundleItemList);
  };

  const createRequestBody = () => {
    const data = new FormData();
    data.append("name", bundleName);
    data.append("bundleItems", JSON.stringify(bundleItems));
    data.append("bundle", drawing);
    data.append("description", description);
    data.append("rating", rating);
    data.append("AproximateRate", AproximateRate);
    return data;
  };

  const handleSubmit = async (e) => {
    try {
      e.preventDefault();
      setIsDisabled(true);
      const user = JSON.parse(localStorage.getItem("user"));
      const data = createRequestBody();
      const contractorIds = selectedContractors.map(
        (contractor) => contractor.value
      );
      data.append("contractorIds", JSON.stringify(contractorIds));
      const categoryId = selectedCategory;
      data.append("categoryId", JSON.stringify(categoryId));

      const config = {
        headers: { authorization: `Token ${user.token}` },
      };
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}bundle/create-bundle`,
        data,
        config
      );
      URL.revokeObjectURL(preview);
      if (response) {
        history.push("/admin/view-bundle");
      }
      setIsDisabled(false);
    } catch (error) {
      setIsDisabled(false);
    }
  };

  console.log("bundleItems", bundleItems);


  useEffect(() => {
    // getCategoryList();
    getMaterialTypeList();
    getBrandList();
  }, []);

  return (
    <>
      <Header />
      <div className="container-fluid">
        <div className="row">
          <SideBar />
          <main className="col-md-9 ms-sm-auto col-lg-10 px-md-4">
            <div className="d-flex justify-content-between flex-wrap flex-md-nowrap align-items-center pt-3 pb-2 mb-3 border-bottom">
              <h1 className="h2 fw-bold">Create Bundle</h1>
            </div>

            <div className="col-md-6">
              <form onSubmit={handleSubmit}>
                <div className="row mb-4">
                  <div className="col">
                    <div className="form-outline mb-4">
                      <label className="form-label" htmlFor="weight">
                        Bundle Name
                      </label>
                      <input
                        type="text"
                        id="bundleName"
                        className="form-control"
                        name="bundleName"
                        required
                        onChange={handleBundleName}
                      />
                    </div>
                  </div>
                </div>
                <div className="row mb-4">
                  <div className="col">
                    <div className="form-outline">
                      <label className="form-label" htmlFor="drawing">
                        Drawing
                      </label>
                      <input
                        type="file"
                        id="drawing"
                        accept="image/png, image/jpeg"
                        className="form-control"
                        onChange={handleFileChange}
                        required
                      />
                    </div>
                    {preview && (
                      <img
                        alt=""
                        className="uploaded-preview mt-4"
                        src={preview}
                      />
                    )}
                  </div>
                </div>

                {bundleItems.map((i) => (
                  <BundleItem
                    key={i.id}
                    brandList={brandList}
                    // categoryList={categoryList}
                    materialTypeList={materialTypeList}
                    handleBundleItem={handleBundleItem}
                    id={i.id}
                    removeBundleItem={removeBundleItem}
                  />
                ))}

                <div className="form-outline row ">
                  <button type="button" className="btn" onClick={addBundleItem}>
                    <i className="bi bi-plus-circle pe-2 " />
                    Add Item
                  </button>
                </div>

                <Category onCategoryChange={handleCategoryChange} />

                <Contractors
                  selectedContractors={selectedContractors}
                  onContractorsChange={handleContractorsChange}
                />

                <div className="col mt-4">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="materialName">
                      Description
                    </label>
                    <textarea
                      className="form-control"
                      type="text"
                      rows={3}
                      id="description"
                      value={description}
                      onChange={handleDescription}
                    ></textarea>
                  </div>
                </div>

                <div className="col mt-2">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="materialName">
                      Rating (Out of 5)
                    </label>
                    <input
                      type="text"
                      id="rating"
                      className="form-control"
                      value={rating}
                      onChange={handleRating}
                    />
                  </div>
                </div>

                <div className="col mt-2">
                  <div className="form-outline">
                    <label className="form-label" htmlFor="materialName">
                      Aproximate rate
                    </label>
                    <input
                      type="text"
                      id="rating"
                      className="form-control"
                      value={AproximateRate}
                      onChange={handleAproximateRate}
                    />
                  </div>
                </div>

                {/* <div className="form-outline row mb-4">
                  <button type="button" className="btn" onClick={addBundleItem}>
                    <i className="bi bi-plus-circle pe-2 " />
                    Add Item
                  </button>
                </div> */}
                <button
                  type="submit"
                  className="btn btn-primary2 btn-block mb-4 mt-4"
                  disabled={isDisabled}
                >
                  Add Bundle
                </button>
              </form>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default CreateBundle;
